import TaskLocations from './taskLocationsContainer';

export { default as EditTaskLocationModal } from './EditTaskLocationModal';
export default TaskLocations;
